import { useMediaQuery } from 'react-responsive'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// @ts-ignore
export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 576 })
  return isMobile ? children : null
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// @ts-ignore
export const Desktop = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 577 })
  return isNotMobile ? children : null
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// @ts-ignore
export const DesktopUntilLarge = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 577 })
  const isNotLargeDesktop = useMediaQuery({ maxWidth: 1439 })
  return isNotMobile && isNotLargeDesktop ? children : null
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// @ts-ignore
export const DesktopLarge = ({ children }) => {
  const isLargeDesktop = useMediaQuery({ minWidth: 1440 })
  return isLargeDesktop ? children : null
}
